import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {filter} from "rxjs";
import {HttpParams} from "@angular/common/http";

@Component({
  selector: 'app-grammar',
  templateUrl: './grammar.component.html',
  styleUrl: './grammar.component.scss',
  standalone: false
})
export class GrammarComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
  }

  categoryId: number = null;
  type: string = null;
  selectedTabIndex: number = 0;

  ngOnInit() {
    this.route.queryParams
      .pipe(filter(params => !!params['id'] || !!params['c_id'] || !!params['type']))
      .subscribe((queryParams: HttpParams) => {
        this.type = queryParams['type'];
        if(this.type === 'func'){
          this.selectedTabIndex = 2;
        } else if(this.type === 'sys'){
          this.selectedTabIndex = 1;
        }
      });
  }

}
